import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { setEditorAvailable, setFinalcutsAvailable } from 'components/app/_mediator/app.slice';
import { selectFiles } from 'components/app/_mediator/app-files.slice';

export const useAppAvailable = () => {
  const { isAudio, isVideo, isImage, brokenFiles } = useAppSelector(selectFiles);
  const projectLoaded = useAppSelector((state) => state.app.projectLoaded);
  const editorAvailable = useAppSelector((state) => state.app.editorAvailable);
  const finalcuts = useAppSelector((state) => state.app__data.finalcuts);
  const storyLoaded = useAppSelector((state) => state.app.storyLoaded);
  const stories = useAppSelector((state) => state.app__data.stories);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      setEditorAvailable(projectLoaded && isAudio && (isVideo || isImage) && !!stories?.length && !brokenFiles.length)
    );
  }, [projectLoaded, isAudio, isVideo, isImage, brokenFiles, stories?.length]);

  useEffect(() => {
    dispatch(setFinalcutsAvailable(storyLoaded && editorAvailable && !!finalcuts.length));
  }, [storyLoaded, editorAvailable, finalcuts.length]);
};
